export type GapToken =
  | "none"
  | "xxsmall"
  | "xsmall"
  | "small"
  | "medium"
  | "large"
  | "xlarge"
  | "component-xxsmall"
  | "component-xsmall"
  | "component-small"
  | "component-medium"
  | "component-large"
  | "component-xlarge"
  | "component-xxlarge";

export const gapToClass: Record<GapToken, string> = {
  none: "gap-0",
  xxsmall: "gap-layout-xxsmall",
  xsmall: "gap-layout-xsmall",
  small: "gap-layout-small",
  medium: "gap-layout-medium",
  large: "gap-layout-large",
  xlarge: "gap-layout-xlarge",
  "component-xxsmall": "gap-component-xxsmall",
  "component-xsmall": "gap-component-xsmall",
  "component-small": "gap-component-small",
  "component-medium": "gap-component-medium",
  "component-large": "gap-component-large",
  "component-xlarge": "gap-component-xlarge",
  "component-xxlarge": "gap-component-xxlarge",
};
